import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "90 days inactive", { props: { triggerType: "Tag Added", tag: "inactive-90d", event: "inactive-90d" } }],
  ["e1", "auto-email", "We miss you", { props: { subject: "It's been a while — here's what's new" } }],
  ["w1", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["c1", "auto-condition", "Opened?", { props: { condition: "Opened 'We miss you'" } }],
  ["e2", "auto-email", "20% welcome-back offer", { props: { subject: "20% off, just for coming back" } }],
  ["w2", "auto-wait", "Wait 4 days", { props: { duration: "4", unit: "days" } }],
  ["e3", "auto-email", "The breakup email", { props: { subject: "Should we stop emailing you?" } }],
  ["tg", "auto-tag-add", "Tag: churned", { props: { tag: "churned" } }],
]);

const def: TemplateDef = {
  slug: "winback-reengagement",
  name: "Win-Back / Re-Engagement",
  category: "E-commerce",
  tagline:
    "Wake up dormant contacts with a miss-you note, an offer, and a clean breakup.",
  description:
    "A free win-back email sequence template: trigger on 90 days of inactivity, send a re-engagement note, branch on opens, make a welcome-back offer, and end with the classic breakup email that cleans your list. Clone it into FrazzleCRM to run it.",
  whatsInside: [
    "Inactivity trigger (fire it from a segment or a tag)",
    "Miss-you email with an opened? branch",
    "20% welcome-back offer for the engaged half",
    "Breakup email + churned tag to keep your list honest",
  ],
  flow: makeFlow(
    [
      node("n1", "util-note", "Entry", 40, 90, {
        notes:
          "Tag contacts 'inactive-90d' from a segment (no order / no login in 90 days). The tag fires this flow.",
      }),
      flow("f1", "Win-Back Sequence", 360, 40, 420, 850),
      ...seq.nodes,
      node("sp", "page-sales", "Welcome-back offer", 880, 240, { props: { price: "20% off" } }),
      node("ty", "page-thankyou", "They're back 🎉", 1200, 240),
    ],
    [...seq.edges, edge("f1", "sp"), edge("sp", "ty")]
  ),
};

export default def;
